import React from "react";
import CaseHero from "../commonCase/CaseHero";
import icon from "../../../../assets/svgs/ggpsvg.svg";
import Task from "../commonCase/Task";
import Task1 from "../commonCase/Task1";
import website from "../../../../assets/images/ggpimg.webp";
import Design from "../commonCase/Design";
import work1 from "../../../../assets/images/ggpwork1.webp";
import work2 from "../../../../assets/images/ggpwork2.webp";
import Work from "../commonCase/Work";
import result1 from "../../../../assets/svgs/softsidecard1.svg";
import result2 from "../../../../assets/svgs/softsidecard2.svg";
import result3 from "../../../../assets/svgs/softsidecard3.svg";
import Result from "../commonCase/Result";
import linkdin from "../../../../assets/svgs/linkdin 2.svg";
import Data from "../../Data";
import tanks from "../../../../assets/svgs/tankssvg.svg";
import softside from "../../../../assets/svgs/softsidesvg.svg";
import aes from "../../../../assets/svgs/aessvg.svg";
import OtherProject from "../commonCase/OtherProject";

const tableData = [
  { task: "Logo Design", status: true },
  { task: "Website Design & Dev", status: true },
  { task: "Branding", status: true },
  { task: "Linkedin Marketing", status: true },
];

const task1Data = [
  {
    subheading: "Website Architecture & Layout: ",
    des: "Structured the site to guide visitors naturally through offerings, proof and action, without distractions or decision fatigue.",
  },
  {
    subheading: "Copywriting & Brand Messaging: ",
    des: "Wrote clear, client-focused content that positions GGP as a trusted expert and speaks directly to business decision-makers.",
  },
  {
    subheading: "Visual Identity & UI Design: ",
    des: "Crafted a clean, high-trust design that reflects GGP’s authority and communicates professionalism within seconds of landing.",
  },
  {
    subheading: "Full-Stack Development: ",
    des: "Built the site for fast load times and full responsiveness across all major devices, browsers and screen sizes.",
  },
  {
    subheading: "Conversion Strategy Implementation: ",
    des: "Placed CTAs, reviews, and lead triggers with intention, designed to drive action and build user confidence.",
  },
];

const task2Data = [
  {
    subheading: "Logo Design: ",
    des: "Designed a clean logo that reflects the strategic mindset and feels credible across web, print, and presentations.",
  },
  {
    subheading: "LinkedIn Banner: ",
    des: "Designed a powerful banner that instantly communicates who they help, how they do it and why it matters."
  },
  {
    subheading: "Business Card: ",
    des: "Created a minimal, premium-looking business card that feels personal, sharp and easy to carry into every conversation",
  },
];

const images = [work1, work2];

const cardData = [
  {
    icon: result1,
    subheading: "Stronger Brand Perception",
    text: "Refreshed branding helped them show up with more authority, instantly building trust and positioning them as a premium consulting partner for serious growth-focused businesses.",
  },
  {
    icon: result2,
    subheading: "Better Website Engagement",
    text: "The new website experience reduced confusion and helped visitors clearly understand services, leading to longer time spent, better click-throughs and higher interest in their offerings",
  },
  {
    icon: result3,
    subheading: "Increased Founder Visibility",
    text: "With professionally designed LinkedIn banners and business cards, GGP’s founder now connects with prospects more confidently in both digital outreach and high-stakes networking scenarios.",
  },
];

const linkData = [
  {
    logo: linkdin,
    link: "https://www.linkedin.com/company/civilengineringrecruitment",
    linkName: "Linkdin.AesRecuriment",
  },
];
const project = [
  {
    name: "SoftSide",
    img: softside,
    link: "/case-study/softside",
  },
  {
    name: "TanskandCovers",
    img: tanks,
    link: "/case-study/tanksandcover",
  },
  {
    name: "AesRecruitment",
    img: aes,
    link: "/case-study/aes",
  },
];

const Ggp = () => {
  return (
    <div className="pt-[100px] lg:pt-[80px]">
      <CaseHero
        name=""
        highlited="Global Growth Partners"
        title="Case Study for"
        icon={icon}
        subtitle="Website Design and Development, Branding "
        date={2024}
      />
      <Task
        rows={tableData}
        bgColor="bg-[#1E7B3C]" // Custom background color
        headerColor="bg-[#333333]" // Custom header color
        className=""
        text1="Global Growth Partners, a business consulting firm specializing in sales and marketing strategies, sought to establish a compelling digital presence. Their goal was to effectively communicate their value proposition, attract potential clients and position themselves as a trusted partner for business growth. However, they lacked a cohesive brand identity and a user-friendly website to showcase their services and success stories."
      />
      <Task1
        heading="Website Design & Development"
        text="We built the GGP website from the ground up and here’s how we did it."
        list={task1Data}
        listcolor="text-[#1E7B3C]"
        listStyleColor="fill-[#1E7B3C]"
      />
      <Design
        heading="Website design"
        bgcolor="bg-[#1E7B3C]"
        img={website}
        link="https://getagrowthpartner.com/"
        linkName="getagrowthpartner.com"
      />
      <Task1
        heading="Branding"
        text="Our focus was on building brand pieces representing GGP’s expertise, wherever their audience sees them."
        list={task2Data}
        listcolor="text-[#1E7B3C]"
        listStyleColor="fill-[#1E7B3C]"
      />
      <Work
        bgColor="bg-[#1E7B3C]"
        heading="Logo Design"
        img={images}
        link={linkData}
        grid="lg:grid-cols-2"
      />
      <Result
        cardColor="bg-[#333333]"
        heading="Results"
        text="Here’s what changed after we stepped in "
        cards={cardData}
      />
      <OtherProject project={project} />
      <Data />
    </div>
  );
};

export default Ggp;
